module.exports = __webpack_public_path__ + "img/casitaMobile.3dfeed94.svg";